@if (hasWeightAndDimensionData()) {
<div class="details-card-wrapper">
    <!-- Heading -->
    <h2>Dimensions and Weight</h2>

    <div class="details-card">
        <div class="details-card-body">
            <ul class="secondary-info-list">
                @if (product()?.dimensions) {
                <li class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-5 p-0">
                        <h3>Dimensions (cm)</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ product().dimensions }}</p>
                    </div>
                </li>
                }
                @if (product()?.weight) {
                <li class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-5 p-0">
                        <h3>Weight (kg)</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ product().weight || 0 | roundoff }}</p>
                    </div>
                </li>
                }
                @if (product()?.unit; as unit) {
                <li class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-5 p-0">
                        <h3>Unit</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ unit?.display_name || unit?.name | notApplicable }}</p>
                    </div>
                </li>
                }
                @if (product()?.manufacturer) {
                <li class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-5 p-0">
                        <h3>Manufacturer</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ product().manufacturer | notApplicable }}</p>
                    </div>
                </li>
                }
                @if (product()?.country_of_origin) {
                <li class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-5 p-0">
                        <h3>Country of Origin</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-7">
                        <p>{{ product().country_of_origin | notApplicable }}</p>
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
</div>
}